module.exports = __webpack_public_path__ + "img/dongji_ps_22.8716bc30.jpg";